import { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../context/Context";
import "./EquipmentsListModal.css";

const EquipmentsListModal = () => {
  const {
    setEquipmentsListModal,
    currenRoom,
    handleEquipmentsNameModal,
    addedTypeEquipment,
    setAddedTypeEquipment,
    setCloseEquipmentListButton,
  } = useContext(Context);
  const modalName = useRef(null);
  const closeButton = useRef(null);
  useEffect(() => {
    setEquipmentsListModal(modalName);
    setCloseEquipmentListButton(closeButton);
  }, []);

  const handleClickOnEquipment = (state, type) => {
    handleEquipmentsNameModal(state);
    setAddedTypeEquipment(type);
  };
  return (
    // Modal
    <div
      className="modal fade"
      id="equipmentsList"
      tabIndex="-1"
      aria-labelledby="equipmentsListLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsListLable">
              انتخاب تجهیز
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex justify-content-around flex-wrap">
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 3)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/9p.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">ریموت</p>
                </div>
              </div>
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 4)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/Ao1.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">دیمر</p>
                </div>
              </div>
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 503)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/ik.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">رطوبت</p>
                </div>
              </div>
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 501)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/Om.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">فن کویل</p>
                </div>
              </div>
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 401)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/NO.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">کلید سناریو</p>
                </div>
              </div>
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 100)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/5N.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">تلویزیون</p>
                </div>
              </div>
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 1)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/c0.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">کلید</p>
                </div>
              </div>
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 99)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/89.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">کلید بیسیم</p>
                </div>
              </div>
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 9)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/Zu.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">RGB</p>
                </div>
              </div>
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 5)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/JD.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">ترموستات</p>
                </div>
              </div>
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 502)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/UW.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">موتور خانه</p>
                </div>
              </div>
              {/* <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 9997)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/fC.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">دوربین</p>
                </div>
              </div> */}
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 9998)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/Gb.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">ورودی</p>
                </div>
              </div>
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 9999)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/input_set.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">تنظیم ورودی</p>
                </div>
              </div>
              <div
                className="card h-100 equipment mx-2 mt-3"
                onClick={() => handleClickOnEquipment(true, 600)}
              >
                <img
                  className="card-img-top"
                  src="/assets/img/app-icons/dataloggershortcut.png"
                  alt="Card image cap"
                />
                <div className="card-body py-0">
                  <p className="card-title text-center mb-3">دیتا لاگر</p>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="modal-footer"></div> */}
        </div>
      </div>
    </div>
  );
};

export default EquipmentsListModal;